module.exports = __webpack_public_path__ + "images/formSummaryIcon.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/formSummaryIcon.png
// module id = 2128
// module chunks = 0